<template>
    <div class="mobilnav-box" :class='{isShow:isShow,isNon:isNon,isMove:Moveactive}'
        :style='{backgroundImage:"url("+imgurl+")"}'>
        <div class="center-box">
            <ul class="mobilnav-nav-ul">
                <li class="mobilnav-nav-li" :class='{isType:typeshow==index}' v-for='(item,index) in navData'
                    :key='index'><a class="linke" :class="{isActive:linkeActive===index}" :href='item.path'
                        @mouseover='mouseover1(item.imgurl,index)' @mouseout='mouseout1'>{{item.name}}</a></li>
            </ul>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'MobilNav',
        data() {
            return {
                typeshow: 0,//选中
                Moveactive: false,//是否触摸
                linkeActive: '',//是否选中
                isShow: true,//是否隐藏
                isNon: true,//是否转为none
                imgurl: '',//背景图片
                navData: [
                    {
                        name: '首页',
                        path: '/',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                        imgurl: require('../../assets/navMobile/banner1.jpg')
                    },
                    {
                        name: '解决方案',
                        path: '/program',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg'
                        imgurl: require('../../assets/navMobile/banner2.jpg')
                    },
                    {
                        name: '精彩案例',
                        path: '/case',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg'
                        imgurl: require('../../assets/navMobile/banner1.jpg')
                    },
                    {
                        name: '关于我们',
                        path: '/about',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg'
                        imgurl: require('../../assets/navMobile/banner3.jpg')
                    },
                    {
                        name: '蓝鲸营销学院',
                        path: '/school',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg'
                        imgurl: require('../../assets/navMobile/banner5.jpg')
                    },
                    {
                        name: '常见问题',
                        path: '/faq',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg'
                        imgurl: require('../../assets/navMobile/banner4.jpg')
                    },
                    {
                        name: '联系我们',
                        path: '/contact',
                        // imgurl:'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg'
                        imgurl: require('../../assets/navMobile/banner6.jpg')
                    },
                ]
            }
        },
        mounted() {
            this.getURL()
        },
        methods: {
            changeShow() {
                if (this.isNon) {
                    this.isNon = false
                    let _this = this
                    setTimeout(() => {
                        _this.isShow = false
                    }, 300)
                } else {
                    this.isShow = true
                    let _this = this
                    setTimeout(() => {
                        _this.isNon = true
                    }, 500)
                }
            },
            mouseover1(url, num) {
                this.imgurl = url
                this.Moveactive = true
                this.linkeActive = num
            },
            mouseout1() {
                this.Moveactive = false
                this.linkeActive = ''
                this.imgurl = ''
            },
            getURL() {
                let url = this.$route.path
                url = url.split('/')
                switch (url[1]) {
                    case '':
                        this.typeshow = 0
                        break;
                    case 'program':
                        this.typeshow = 1
                        break;
                    case 'case':
                        this.typeshow = 2
                        break;
                    case 'about':
                        this.typeshow = 3
                        break;
                    case 'school':
                        this.typeshow = 4
                        break;
                    case 'faq':
                        this.typeshow = 5
                        break;
                    case 'contact':
                        this.typeshow = 6
                        break;
                }
            }
        }
    }
</script>
<style scoped>
    .mobilnav-box {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        opacity: 1;
        z-index: 70;
        transition: all 0.5s;
        background: #000000 no-repeat center;
        background-size: cover;
    }

    .center-box {
        width: 100%;
        height: 100%;
        position: relative;
        background-color: rgba(0, 0, 0, 1);
        transition: all 1s;
    }

    .mobilnav-nav-ul {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding-left: 528px;
    }

    .isType {
        list-style: disc;
        color: #02AED6;
        font-size: 35px;

    }

    /* .mobilnav-nav-li::after{

    } */
    .mobilnav-nav-li:not(:last-child) {
        margin-bottom: 40px;
    }

    .linke {
        color: #ffffff;
        font-size: 38px;
        transition: all 0.3s;
    }

    .isShow {
        opacity: 0;
    }

    .isNon {
        display: none;
    }

    .isMove .center-box {
        background-color: rgba(0, 0, 0, .3);
    }

    .isMove .linke {
        color: rgba(255, 255, 255, .3);
    }

    .isMove .isActive {
        color: rgba(255, 255, 255, 1);
    }

    @media(max-width: 995px) {
        .mobilnav-nav-ul {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding-left: 0;
    }
        .linke {
            font-size: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/base/mobilnav.vue